import { defineComponent } from "vue";
import NavHeaderVue from "@/components/nav-header/NavHeader.vue";
import VideoMain from "./cpns/videoMain.vue";
export default defineComponent({
  name: "MvDetail",
  setup: function setup() {
    return {};
  },
  components: {
    NavHeaderVue: NavHeaderVue,
    VideoMain: VideoMain
  }
});